var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from "@mui/material";
import { useLocalize } from "../../utils/text.util";
export var CommonConfirmDialog = function (props) {
    var _a, _b, _c, _d;
    var t = useLocalize().t;
    return (_jsxs(Dialog, __assign({ open: props.open, onClose: props.onClose }, { children: [_jsx(DialogTitle, __assign({ id: "alert-dialog-title" }, { children: (_a = props.title) !== null && _a !== void 0 ? _a : t("Are you sure?") })), props.message &&
                _jsx(DialogContent, { children: _jsx(DialogContentText, { children: props.message }) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: props.onClose }, { children: (_b = props.cancelLabel) !== null && _b !== void 0 ? _b : t('Close') })), _jsx(Button, __assign({ onClick: function () {
                            var _a;
                            (_a = props.onConfirm) === null || _a === void 0 ? void 0 : _a.call(props);
                        }, variant: 'contained', color: (_c = props.confirmColor) !== null && _c !== void 0 ? _c : 'primary' }, { children: (_d = props.confirmLabel) !== null && _d !== void 0 ? _d : t('Confirm') }))] })] })));
};
export default CommonConfirmDialog;
